import { QUALIFICATION_CODES } from '../../../shared/constants/qualification-code';
import { NestingQualification } from '../../../shared/interfaces/quota-nesting.interface';
import { Criteria } from '../../../shared/interfaces/quota.interface';
import { NestedCriterionDescriptionBuilder } from '../../domain/nested-criterion-description-builder';

interface CombinedKeyBuild {
  build(): string[];
}
export class NestedQuotaCombinedKeyBuilder implements CombinedKeyBuild {
  constructor(
    private readonly _criteria: Criteria[],
    private readonly _qualifications: NestingQualification[]
  ) {}

  public build(): string[] {
    return (this._criteria ?? []).map((criterion) => {
      const matchingQualification = this._matchingQualification(
        criterion.qualification_code
      );
      return new NestedCriterionDescriptionBuilder(
        criterion,
        matchingQualification
      ).build();
    });
  }

  private _matchingQualification(
    qualificationCode: number
  ): NestingQualification {
    const modifiedQualificationCode = [
      QUALIFICATION_CODES.CHILD_GENDER,
      QUALIFICATION_CODES.CHILD_AGE,
    ].includes(Number(qualificationCode))
      ? QUALIFICATION_CODES.CHILDREN
      : qualificationCode;

    return this._qualifications.find(
      (q) => Number(q.qualification_code) === Number(modifiedQualificationCode)
    )!;
  }
}
